import { Box, Link } from '@mui/material';

import Typography from '@/components/Typography';
import { SUPPORT_EMAIL } from '@/constants/constants';
import { spacing } from '@/constants/ui';

export const ErrorMessage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing['2']
      }}
    >
      <Typography
        size={32}
        sx={{
          fontWeight: 'bold'
        }}
      >
        We're having trouble connecting right now.
      </Typography>
      <Typography
        size={20}
        sx={{
          fontWeight: 'bold'
        }}
      >
        Please check your connection and try again, or{' '}
        <Link
          href={`mailto:${SUPPORT_EMAIL}`}
          sx={{
            color: 'primary.main',
            cursor: 'pointer'
          }}
          underline='hover'
        >
          contact us
        </Link>
      </Typography>
    </Box>
  );
};

export default ErrorMessage;
